// Zulässiges Team-Farbspektrum für Turniere.
// Farben werden als Schlüssel (String) im Backend gespeichert, das Frontend
// mappt sie auf Tailwind-Klassen für Preview-Kachel + Live-Tabellen-Streifen.

export const TEAM_COLORS = [
  { key: "blau",     label: "Blau",     cls: "bg-blue-600",    hex: "#2563eb" },
  { key: "hellblau", label: "Hellblau", cls: "bg-sky-400",     hex: "#38bdf8" },
  { key: "rot",      label: "Rot",      cls: "bg-red-500",     hex: "#ef4444" },
  { key: "orange",   label: "Orange",   cls: "bg-orange-400",  hex: "#fb923c" },
  { key: "pink",     label: "Pink",     cls: "bg-pink-400",    hex: "#f472b6" },
  { key: "gruen",    label: "Grün",     cls: "bg-emerald-500", hex: "#10b981" },
  { key: "weiss",    label: "Weiß",     cls: "bg-zinc-100",    hex: "#f4f4f5" },
  { key: "gelb",     label: "Gelb",     cls: "bg-yellow-400",  hex: "#facc15" },
];

// Legacy-Alias-Map — falls Turniere aus dem alten Farbspektrum (brand/sky/amber…)
// noch im Bestand sind, mappen wir auf die neue Palette.
const LEGACY_MAP = {
  brand: "blau",
  sky: "hellblau",
  amber: "gelb",
  rose: "rot",
  fuchsia: "pink",
  emerald: "gruen",
  orange: "orange",
  cyan: "hellblau",
  violet: "pink",
  yellow: "gelb",
  red: "rot",
  blue: "blau",
  green: "gruen",
  white: "weiss",
};

export function resolveTeamColor(key, fallbackIdx = 0) {
  if (!key) return TEAM_COLORS[fallbackIdx % TEAM_COLORS.length];
  const resolvedKey = LEGACY_MAP[key] || key;
  return TEAM_COLORS.find((c) => c.key === resolvedKey)
    || TEAM_COLORS[fallbackIdx % TEAM_COLORS.length];
}
